import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import { createAction } from 'redux-act';
import url from 'url';
import * as Constants from "../constants";

var getQuery = function getQuery() {
  if (typeof window === 'undefined') return {};
  var result;

  try {
    result = _get(url.parse(window.location.href, true), 'query', {});
  } catch (e) {
    result = {};
  }

  return result;
};

var getPageTaxonomy = function getPageTaxonomy() {
  if (typeof window === 'undefined') return {};
  return _get(window, 'nwPageTaxonomy', {});
};

var getLegacyTrkParams = function getLegacyTrkParams() {
  var query = getQuery();
  return {
    trk_origin: query.trk_origin,
    trk_source: query.trk_source,
    trk_version: query.trk_version,
    trk_location: query.trk_location,
    trk_format: query.trk_format
  };
};

export var updateTrackingParams = createAction('TRACK: Update tracking params', function (_ref) {
  var _ref$trk = _ref.trk,
      trk = _ref$trk === void 0 ? {} : _ref$trk,
      _ref$amplitudeOnlyTrk = _ref.amplitudeOnlyTrk,
      amplitudeOnlyTrk = _ref$amplitudeOnlyTrk === void 0 ? {} : _ref$amplitudeOnlyTrk,
      appName = _ref.appName;
  var query = getQuery();

  var trkParams = _objectSpread(_objectSpread({}, getLegacyTrkParams()), {}, {
    trk_mode: Constants.Mode.EMBED,
    trk_channel: query.utm_medium === 'email' ? Constants.Channel.EMAIL : Constants.Channel.WEB
  });

  if (trkParams.trk_channel === 'web') {
    var nwPageTaxonomy = getPageTaxonomy();
    trkParams = _objectSpread(_objectSpread({}, trkParams), {}, {
      trk_vertical: query.trk_vertical || nwPageTaxonomy.vertical,
      trk_topic: query.trk_topic || nwPageTaxonomy.topic,
      trk_nldt: query.trk_nldt || nwPageTaxonomy.pageType,
      trk_pagetype: query.trk_pagetype || nwPageTaxonomy.contentType,
      trk_element: query.trk_element || Constants.Element.DEFAULT,
      trk_location: query.trk_location,
      trk_copy: query.trk_copy
    });
  }

  return {
    trk: _objectSpread(_objectSpread({}, trkParams), trk),
    amplitudeOnlyTrk: amplitudeOnlyTrk,
    appName: appName
  };
});